export var HeroStageType;
(function (HeroStageType) {
    HeroStageType["DefaultHero"] = "defaultHero";
    HeroStageType["DiagonalHero"] = "diagonalHero";
    HeroStageType["BoxHero"] = "boxHero";
})(HeroStageType || (HeroStageType = {}));
